import { ApiConnector } from 'Connectors/ApiConnector';
import ConfigProxy      from 'tools/ConfigProxy';
import AbstractApiModel from './AbstractApiModel';

export const exportConnector = new ApiConnector({
	baseURL: ConfigProxy.getServiceConfig('export', 'api_endpoint'),
});

export default class ExportApiModel extends AbstractApiModel {
	public static get connector() {
		return exportConnector;
	}

	public static serviceName: ServiceName = 'export';
}
